<template>
  <div>
    <b-row>
      <b-col>
        <span :style="'padding-left: ' + (level * 1.28571) + 'em'">
          <i class="fa fa-fw" :class="{
            'fa-plus-square-o': collapsed && value.rows && value.rows.length,
            'fa-minus-square-o': !collapsed && value.rows && value.rows.length
          }" @click.prevent="collapsed = !collapsed"></i>
          {{ value.header }}
        </span>
      </b-col>
      <template v-for="(v, index) in value.values">
        <slot name="value" :row="value" :value="v" :index="index"></slot>
      </template>
    </b-row>
    <div :class="{ 'd-none': collapsed }">
      <template v-for="row in value.rows">
        <display-table-row
          :value="row"
          :level="level + 1">
          <template v-slot:value="{ row: r, value: v, index: i }">
            <slot name="value" :row="r" :value="v" :index="i"></slot>
          </template>
        </display-table-row>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object
    },

    level: {
      type: Number,
      default: 0
    },
  },

  data() {
    return {
      collapsed: false
    };
  }
}
</script>
